module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAMAAACDzGUcAAAAAXNSR0IB2cksfwAAAD9QTFRFAAAAaGhyaGhxaGhxaGhwaWlwaGhxcHBwaGhwaGhxaWlyaGhxaGhwaGhxaGhyampwaGhxaGhxZ2dxaGhxZ2dxmeUnqwAAABV0Uk5TAIDA4EBQoBB/sHDQIJBgMN+/7/DPKrxZ/gAAAHZJREFUeJxtj+0agBAMhWlYE6nW/V9riXyU82M8r+04E3ICJQbSZkQR5o8wYjKyU7K0sh9enuqWDjrKj66l1qbTry2l3BOopfC7dPGNrrTa6W0vOrA08Hfh9G8YUc/wOvBZ0gMiqChvmhB80zdXpStDDkQnOHEByB0EdrLlMAAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-cart-inactive.png
// module id = 750
// module chunks = 1